import React, { useEffect, useState } from 'react'
import st from './DoubleCRM.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import RowClientDuplicate from './RowClientDuplicate/RowClientDuplicate'
import { superAxiosRequest } from 'axiosApi'
import { useHistory } from 'react-router-dom'
import Pagination from 'components/UI/Pagination/Pagination'
import { observer } from 'mobx-react'
import Loader from 'components/ContentBox/Global/Loader/Loader'

const initPagination = {
  page: 1,
  limit: 10,
}

// Функция для получения дат за последний месяц
const getLastMonthDates = () => {
  const today = new Date()
  const lastMonth = new Date(today)
  lastMonth.setMonth(lastMonth.getMonth() - 1)

  const formatDate = (date) => {
    return date.toISOString().split('T')[0]
  }

  return {
    date_from: formatDate(lastMonth),
    date_until: formatDate(today),
  }
}

const DoubleCrm = () => {
  const history = useHistory()
  const lastMonthDates = getLastMonthDates()

  const [filter, updateFilter] = useLocalStorageFilter({})
  const [duplicates, setDuplicates] = useState([])
  // const [pagination, setPagination] = useState(initPagination)
  const [loading, setLoading] = useState(false)
  const {
    isOpenFilter,
    setTextValues,
    closeFilter,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore

  const fetchDuplicates = () => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/duplicate_deal',
      crm: true,
      params: {
        ...filter,
        // offset: (pagination.page - 1) * pagination.limit,
        // limit: pagination.limit,
      },
    }).then(({ data }) => {
      console.log(data)
      setDuplicates(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    // Этот useEffect сработает только один раз при монтировании
    const initializeFilter = () => {
      // Проверяем, нужно ли установить даты по умолчанию
      if (!filter.date_from || !filter.date_until) {
        updateFilter({
          ...filter,
          date_from: lastMonthDates.date_from,
          date_until: lastMonthDates.date_until,
        })
      }
    }

    initializeFilter()
  }, []) // Пустой массив зависимостей = запуск только при монтировании

  useEffect(() => {
    // Этот useEffect срабатывает при изменении filter
    if (filter.date_from && filter.date_until) {
      setDuplicates(null)
      fetchDuplicates()
      setLoading(true)
    }
  }, [filter])

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      search_duplicates: 'Search for duplicates',
      duplicates_detected: 'Duplicates detected',

      start_finish_date: 'Start & Finish Date',
      search_client_name: 'Search for client name',
      phone_number: 'Phone number',
    },
  })

  const config = [
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: translate.start_finish_date,
      isRequired: true,
    },
    {
      nameState: 'name',
      placeholder: translate.search_client_name,
      type: 'input',
      label: translate.search_client_name,
    },
    {
      nameState: 'phone',
      placeholder: translate.phone_number,
      type: 'input',
      label: translate.phone_number,
    },
    {
      nameState: 'email',
      placeholder: 'E-mail',
      type: 'input',
      label: 'E-mail',
    },
  ]

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/crm/double') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])
  console.log(duplicates?.length)
  return (
    <div>
      <div className={st.header}>
        <div>
          <PageHeader title={translate?.search_duplicates}></PageHeader>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, name: text })
              changeTextValue('name', {
                key: 'name',
                label: translate?.search,
                value: text,
              })
            }}
            onClear={() => {
              const { name: text, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'name'),
              )
            }}
            value={filter?.name || ''}
            placeholder={`${translate?.search}...`}
            translate={translate}
          />
          {duplicates?.length > 0 && (
            <div className={st.countSt}>
              {' '}
              {duplicates?.length > 0
                ? `${translate?.duplicates_detected}:  ${duplicates?.reduce((acc, el) => el.deals?.length + acc, 0)}`
                : null}
            </div>
          )}
        </div>
        {/*{!!filterTextValues.length && (*/}
        {/*  <FilterTextValues*/}
        {/*    onDelete={(key) => {*/}
        {/*      const { [key]: _, ...obj } = filter*/}
        {/*      updateFilter(obj)*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
        {isOpenFilter && (
          <AsideFilter
            getFilterParams={(e) => {
              updateFilter(e)
            }}
            config={config}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
            translate={translate}
          />
        )}
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className={st.containerClient}>
          {duplicates?.length > 0 ? (
            duplicates.map((duplicate, index) => (
              <RowClientDuplicate
                key={`${duplicate.id}${index}`}
                duplicate={duplicate}
                setDuplicates={setDuplicates}
                duplicates={duplicates}
                fetchDuplicates={fetchDuplicates}
              />
            ))
          ) : duplicates && duplicates.length === 0 ? (
            // Данные загружены, но пустой массив
            <div className={st.noData}>
              <p>{translate?.no_duplicates_found || 'Дубликатов не найдено'}</p>
            </div>
          ) : null}
        </div>
      )}
      {/*<div className={st.pagination}>*/}
      {/*  {duplicates?.length > 10 && (*/}
      {/*    <Pagination*/}
      {/*      limit={pagination.limit}*/}
      {/*      count={duplicates?.length || 0}*/}
      {/*      page={pagination.page}*/}
      {/*      onChange={(page) => setPagination({ ...pagination, page })}*/}
      {/*      onChangePerPage={(limit) => {*/}
      {/*        setPagination({ page: 1, limit })*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  )}*/}
      {/*</div>*/}
    </div>
  )
}

export default observer(DoubleCrm)
